import * as Mod1 from "./admin-live-route-map";
import * as Mod2 from "./discourse/app/services/live-calls";
import * as Mod3 from "./discourse/app/services/live-rooms";
import * as Mod4 from "./discourse/app/services/live-webrtc";
import * as Mod5 from "./discourse/components/live-back-to-live-room-button";
import * as Mod6 from "./discourse/components/live-invite-agent-button";
import * as Mod7 from "./discourse/components/live-participant-sidebar-context-menu";
import * as Mod8 from "./discourse/components/live-participant-sidebar-suffix";
import * as Mod9 from "./discourse/components/live-ptt-key-capture";
import * as Mod10 from "./discourse/components/live-room-form";
import * as Mod11 from "./discourse/components/live-room-sidebar-context-menu";
import * as Mod12 from "./discourse/components/live/call-button";
import * as Mod13 from "./discourse/components/live/call-controls";
import * as Mod14 from "./discourse/components/live/call-submenu";
import * as Mod15 from "./discourse/components/live/call-widget";
import * as Mod16 from "./discourse/components/live/caption-overlay";
import * as Mod17 from "./discourse/components/live/chat-panel";
import * as Mod18 from "./discourse/components/live/global-call-layer";
import * as Mod19 from "./discourse/components/live/recording-badge";
import * as Mod20 from "./discourse/components/live/ringing-tile";
import * as Mod21 from "./discourse/components/live/room-page";
import * as Mod22 from "./discourse/components/live/speak-queue";
import * as Mod23 from "./discourse/components/live/transcript-badge";
import * as Mod24 from "./discourse/components/live/video-tile";
import * as Mod25 from "./discourse/components/live/voice-canvas";
import * as Mod26 from "./discourse/components/modal/live-create-room";
import * as Mod27 from "./discourse/components/modal/live-incoming-call";
import * as Mod28 from "./discourse/components/modal/live-invite-agent";
import * as Mod29 from "./discourse/components/modal/live-invite-users";
import * as Mod30 from "./discourse/components/modal/live-mesh-privacy-warning";
import * as Mod31 from "./discourse/components/modal/live-mic-permission";
import * as Mod32 from "./discourse/components/modal/live-room-info";
import * as Mod33 from "./discourse/components/modal/live-video-settings";
import * as Mod34 from "./discourse/components/modal/live-voice-settings";
import * as Mod35 from "./discourse/components/reviewable/live-user";
import * as Mod36 from "./discourse/connectors/user-card-below-message-button/live-call-button.gjs";
import * as Mod37 from "./discourse/connectors/user-profile-controls/live-call-button.gjs";
import * as Mod38 from "./discourse/controllers/live-room";
import * as Mod39 from "./discourse/initializers/live-about";
import * as Mod40 from "./discourse/initializers/live-admin-plugin-configuration-nav";
import * as Mod41 from "./discourse/initializers/live-call-ring";
import * as Mod42 from "./discourse/initializers/live-chat-thread-navbar";
import * as Mod43 from "./discourse/initializers/live-defer-refresh-in-call";
import * as Mod44 from "./discourse/initializers/live-hashtag-type";
import * as Mod45 from "./discourse/initializers/live-notifications";
import * as Mod46 from "./discourse/initializers/live-sidebar";
import * as Mod47 from "./discourse/initializers/live-transcript-draft-icon";
import * as Mod48 from "./discourse/initializers/live-transcript-source";
import * as Mod49 from "./discourse/initializers/live-voice-canvas";
import * as Mod50 from "./discourse/lib/hashtag-types/room";
import * as Mod51 from "./discourse/lib/live-flag";
import * as Mod52 from "./discourse/lib/live/anon-rooms-section";
import * as Mod53 from "./discourse/lib/live/audio-monitor";
import * as Mod54 from "./discourse/lib/live/audio-processing";
import * as Mod55 from "./discourse/lib/live/background-blur";
import * as Mod56 from "./discourse/lib/live/call-alert-dedup";
import * as Mod57 from "./discourse/lib/live/call-constants";
import * as Mod58 from "./discourse/lib/live/fullscreen";
import * as Mod59 from "./discourse/lib/live/heartbeat-manager";
import * as Mod60 from "./discourse/lib/live/idle-tracker";
import * as Mod61 from "./discourse/lib/live/input-gate";
import * as Mod62 from "./discourse/lib/live/invite-ref";
import * as Mod63 from "./discourse/lib/live/live-assets";
import * as Mod64 from "./discourse/lib/live/livekit-coordinator";
import * as Mod65 from "./discourse/lib/live/livekit-session";
import * as Mod66 from "./discourse/lib/live/local-audio-pipeline";
import * as Mod67 from "./discourse/lib/live/local-video-manager";
import * as Mod68 from "./discourse/lib/live/logger";
import * as Mod69 from "./discourse/lib/live/media-devices";
import * as Mod70 from "./discourse/lib/live/mesh-signal-handler";
import * as Mod71 from "./discourse/lib/live/noise-suppression";
import * as Mod72 from "./discourse/lib/live/ns-engines";
import * as Mod73 from "./discourse/lib/live/participant-audio";
import * as Mod74 from "./discourse/lib/live/peer-manager";
import * as Mod75 from "./discourse/lib/live/presence-pending-peers";
import * as Mod76 from "./discourse/lib/live/ptt-manager";
import * as Mod77 from "./discourse/lib/live/ptt-utils";
import * as Mod78 from "./discourse/lib/live/quality-preferences";
import * as Mod79 from "./discourse/lib/live/remote-stream-registry";
import * as Mod80 from "./discourse/lib/live/ringing";
import * as Mod81 from "./discourse/lib/live/room-icon";
import * as Mod82 from "./discourse/lib/live/room-message-queue";
import * as Mod83 from "./discourse/lib/live/roster-handler";
import * as Mod84 from "./discourse/lib/live/sanitize-error";
import * as Mod85 from "./discourse/lib/live/sdp-utils";
import * as Mod86 from "./discourse/lib/live/signaling";
import * as Mod87 from "./discourse/lib/live/sound-effects";
import * as Mod88 from "./discourse/lib/live/speak-queue";
import * as Mod89 from "./discourse/lib/live/stage-roles";
import * as Mod90 from "./discourse/lib/live/stt-models";
import * as Mod91 from "./discourse/lib/live/subtitles";
import * as Mod92 from "./discourse/lib/live/transcript-draft-sync";
import * as Mod93 from "./discourse/lib/live/transcript-markdown";
import * as Mod94 from "./discourse/lib/live/transcript-recorder";
import * as Mod95 from "./discourse/lib/live/transcription-coordinator";
import * as Mod96 from "./discourse/lib/live/url-flag";
import * as Mod97 from "./discourse/lib/live/video-grid-layout";
import * as Mod98 from "./discourse/lib/live/video-quality";
import * as Mod99 from "./discourse/live-route-map";
import * as Mod100 from "./discourse/routes/live-room-invite-legacy";
import * as Mod101 from "./discourse/routes/live-room-invite";
import * as Mod102 from "./discourse/routes/live-room-legacy";
import * as Mod103 from "./discourse/routes/live-room";
import * as Mod104 from "./discourse/templates/live-room";
const compatModules = {
  "admin-live-route-map": Mod1,
  "discourse/app/services/live-calls": Mod2,
  "discourse/app/services/live-rooms": Mod3,
  "discourse/app/services/live-webrtc": Mod4,
  "discourse/components/live-back-to-live-room-button": Mod5,
  "discourse/components/live-invite-agent-button": Mod6,
  "discourse/components/live-participant-sidebar-context-menu": Mod7,
  "discourse/components/live-participant-sidebar-suffix": Mod8,
  "discourse/components/live-ptt-key-capture": Mod9,
  "discourse/components/live-room-form": Mod10,
  "discourse/components/live-room-sidebar-context-menu": Mod11,
  "discourse/components/live/call-button": Mod12,
  "discourse/components/live/call-controls": Mod13,
  "discourse/components/live/call-submenu": Mod14,
  "discourse/components/live/call-widget": Mod15,
  "discourse/components/live/caption-overlay": Mod16,
  "discourse/components/live/chat-panel": Mod17,
  "discourse/components/live/global-call-layer": Mod18,
  "discourse/components/live/recording-badge": Mod19,
  "discourse/components/live/ringing-tile": Mod20,
  "discourse/components/live/room-page": Mod21,
  "discourse/components/live/speak-queue": Mod22,
  "discourse/components/live/transcript-badge": Mod23,
  "discourse/components/live/video-tile": Mod24,
  "discourse/components/live/voice-canvas": Mod25,
  "discourse/components/modal/live-create-room": Mod26,
  "discourse/components/modal/live-incoming-call": Mod27,
  "discourse/components/modal/live-invite-agent": Mod28,
  "discourse/components/modal/live-invite-users": Mod29,
  "discourse/components/modal/live-mesh-privacy-warning": Mod30,
  "discourse/components/modal/live-mic-permission": Mod31,
  "discourse/components/modal/live-room-info": Mod32,
  "discourse/components/modal/live-video-settings": Mod33,
  "discourse/components/modal/live-voice-settings": Mod34,
  "discourse/components/reviewable/live-user": Mod35,
  "discourse/connectors/user-card-below-message-button/live-call-button": Mod36,
  "discourse/connectors/user-profile-controls/live-call-button": Mod37,
  "discourse/controllers/live-room": Mod38,
  "discourse/initializers/live-about": Mod39,
  "discourse/initializers/live-admin-plugin-configuration-nav": Mod40,
  "discourse/initializers/live-call-ring": Mod41,
  "discourse/initializers/live-chat-thread-navbar": Mod42,
  "discourse/initializers/live-defer-refresh-in-call": Mod43,
  "discourse/initializers/live-hashtag-type": Mod44,
  "discourse/initializers/live-notifications": Mod45,
  "discourse/initializers/live-sidebar": Mod46,
  "discourse/initializers/live-transcript-draft-icon": Mod47,
  "discourse/initializers/live-transcript-source": Mod48,
  "discourse/initializers/live-voice-canvas": Mod49,
  "discourse/lib/hashtag-types/room": Mod50,
  "discourse/lib/live-flag": Mod51,
  "discourse/lib/live/anon-rooms-section": Mod52,
  "discourse/lib/live/audio-monitor": Mod53,
  "discourse/lib/live/audio-processing": Mod54,
  "discourse/lib/live/background-blur": Mod55,
  "discourse/lib/live/call-alert-dedup": Mod56,
  "discourse/lib/live/call-constants": Mod57,
  "discourse/lib/live/fullscreen": Mod58,
  "discourse/lib/live/heartbeat-manager": Mod59,
  "discourse/lib/live/idle-tracker": Mod60,
  "discourse/lib/live/input-gate": Mod61,
  "discourse/lib/live/invite-ref": Mod62,
  "discourse/lib/live/live-assets": Mod63,
  "discourse/lib/live/livekit-coordinator": Mod64,
  "discourse/lib/live/livekit-session": Mod65,
  "discourse/lib/live/local-audio-pipeline": Mod66,
  "discourse/lib/live/local-video-manager": Mod67,
  "discourse/lib/live/logger": Mod68,
  "discourse/lib/live/media-devices": Mod69,
  "discourse/lib/live/mesh-signal-handler": Mod70,
  "discourse/lib/live/noise-suppression": Mod71,
  "discourse/lib/live/ns-engines": Mod72,
  "discourse/lib/live/participant-audio": Mod73,
  "discourse/lib/live/peer-manager": Mod74,
  "discourse/lib/live/presence-pending-peers": Mod75,
  "discourse/lib/live/ptt-manager": Mod76,
  "discourse/lib/live/ptt-utils": Mod77,
  "discourse/lib/live/quality-preferences": Mod78,
  "discourse/lib/live/remote-stream-registry": Mod79,
  "discourse/lib/live/ringing": Mod80,
  "discourse/lib/live/room-icon": Mod81,
  "discourse/lib/live/room-message-queue": Mod82,
  "discourse/lib/live/roster-handler": Mod83,
  "discourse/lib/live/sanitize-error": Mod84,
  "discourse/lib/live/sdp-utils": Mod85,
  "discourse/lib/live/signaling": Mod86,
  "discourse/lib/live/sound-effects": Mod87,
  "discourse/lib/live/speak-queue": Mod88,
  "discourse/lib/live/stage-roles": Mod89,
  "discourse/lib/live/stt-models": Mod90,
  "discourse/lib/live/subtitles": Mod91,
  "discourse/lib/live/transcript-draft-sync": Mod92,
  "discourse/lib/live/transcript-markdown": Mod93,
  "discourse/lib/live/transcript-recorder": Mod94,
  "discourse/lib/live/transcription-coordinator": Mod95,
  "discourse/lib/live/url-flag": Mod96,
  "discourse/lib/live/video-grid-layout": Mod97,
  "discourse/lib/live/video-quality": Mod98,
  "discourse/live-route-map": Mod99,
  "discourse/routes/live-room-invite-legacy": Mod100,
  "discourse/routes/live-room-invite": Mod101,
  "discourse/routes/live-room-legacy": Mod102,
  "discourse/routes/live-room": Mod103,
  "discourse/templates/live-room": Mod104,
};
export { compatModules };
export default compatModules;
